import React from 'react';
import { NavLink } from 'react-router-dom';

const AddUserCrumb = () => <NavLink to="/admin/users/add">Add User</NavLink>;

export default AddUserCrumb;
